"use client";

import { useState } from "react";

import { createStyle } from "~/common/utils/create-style";
import { IconClose } from "~/common/components/icons/close";
import { IconFolder } from "~/common/components/icons/folder";
import { IconBurgerMenu } from "~/common/components/icons/burger-menu";
import { WorkspaceSelectDropdown } from "~/workspaces/components/workspace-select-dropdown";

import { Button } from "./button";
import { NavigationLeft } from "./navigation-left";
import { NavigationRight } from "./navigation-right";

function NavigationTop({ className }: { className?: string }) {
  const [isLeftOpen, setIsLeftOpen] = useState(false);
  const [isRightOpen, setIsRightOpen] = useState(false);

  function toggleLeftSidebar() {
    setIsLeftOpen(!isLeftOpen);
  }
  function toggleRightSidebar() {
    setIsRightOpen(!isRightOpen);
  }
  return (
    <>
      <div className={style.container({ className })}>
        <Button
          variant="ghost"
          onClick={toggleLeftSidebar}
          className="text-text-primary"
        >
          {isLeftOpen ? <IconClose /> : <IconBurgerMenu />}
        </Button>

        <div>
          <WorkspaceSelectDropdown />
        </div>

        <Button
          variant="ghost"
          onClick={toggleRightSidebar}
          className="text-text-primary"
        >
          {isRightOpen ? <IconClose /> : <IconFolder />}
        </Button>
      </div>
      {!!isLeftOpen && <NavigationLeft />}
      {!!isRightOpen && <NavigationRight />}
    </>
  );
}

export { NavigationTop };

const style = createStyle({
  slots: {
    container: "flex flex-row w-full justify-between items-center px-16",
  },
})();
